<div class="page-header">
	<h1 class="page-title" *ngIf="loading == false && mode == 'New'">Create Partner</h1>
	<h1 class="page-title" *ngIf="loading == false && mode == 'Edit'">Modify Partner</h1>
	<h1 class="page-title" *ngIf="loading == true">Loading</h1>
</div>

<form *ngIf="partnerForm" [formGroup]="partnerForm" (ngSubmit)="doSubmit()">
	<div class="row">
		<div class="col">
			<div class="card">
				<div class="card-header">
					<h3>Partner Form</h3>
				</div>
				<div class="card-body">
					<div class="form-floating mb-3">
						<input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
						<label for="name">Partner Name</label>
						<div *ngIf="controlInvalid('name')" class="text-danger">{{ getError('name') }}</div>
					</div>
					<div class="form-floating mb-3">
						<select class="form-select" formControlName="partnerType" id="partnerType">
							<option [ngValue]="null" disabled>Select a type</option>
							<option *ngFor="let t of partnerTypes" [ngValue]="t">{{ t }}</option>
						</select>
						<label for="partnerType">Partner Type</label>
						<div *ngIf="controlInvalid('partnerType')" class="text-danger">{{ getError('partnerType') }}</div>
					</div>
					<div class="form-floating mb-3">
						<select class="form-select" formControlName="tenanted" id="isTenanted">
							<option [ngValue]="true">Yes</option>
							<option [ngValue]="false">No</option>
						</select>
						<label for="partnerType">Is Tenanted</label>
						<div *ngIf="controlInvalid('tenanted')" class="text-danger">{{ getError('tenanted') }}</div>
					</div>
					<div class="form-floating mb-3">
						<input type="text" class="form-control" formControlName="registrationNumber"
							id="registrationNumber" placeholder="Registration Number">
						<label for="name">Registration Number</label>
						<div *ngIf="controlInvalid('registrationNumber')" class="text-danger">{{ getError('registrationNumber') }}</div>
					</div>
					<div class="form-floating mb-3">
						<input type="text" class="form-control" formControlName="address" id="address" placeholder="Address">
						<label for="name">Address</label>
						<div *ngIf="controlInvalid('address')" class="text-danger">{{ getError('address') }}</div>
					</div>
					<div class="form-floating mb-3">
						<input type="text" class="form-control" formControlName="iccidPattern" id="iccidPattern"
							placeholder="ICCID Pattern">
						<label for="name">ICCID Pattern</label>
						<div *ngIf="controlInvalid('iccidPattern')" class="text-danger">{{ getError('iccidPattern') }}</div>
					</div>
					<div class="form-floating mb-3">
						<input type="text" class="form-control" formControlName="iccidLength" id="iccidLength"
							placeholder="ICCID Length">
						<label for="name">ICCID Length</label>
						<div *ngIf="controlInvalid('iccidLength')" class="text-danger">{{ getError('iccidLength') }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col" formGroupName="contact" *ngIf="mode=='New'">
			<div class="card">
				<div class="card-header">
					<h3>Contact Form</h3>
				</div>
				<div class="card-body">
					<div class="form-floating mb-2">
						<input type="text" class="form-control" formControlName="fullName" id="contactFullName" placeholder="Full Name">
						<label for="contactFullName">Full Name</label>
						<div *ngIf="controlInvalid('contact.fullName')" class="text-danger">{{ getError('contact.fullName') }}</div>
					</div>
					<div class="form-floating mb-2">
						<input type="email" class="form-control" formControlName="emailAddress" id="contactEmailAddress" placeholder="Email Address">
						<label for="contactEmailAddress">Email Address</label>
						<div *ngIf="controlInvalid('contact.emailAddress')" class="text-danger">{{ getError('contact.emailAddress') }}</div>
					</div>
					<div class="form-floating mb-2">
						<input type="text" class="form-control" formControlName="msisdn" id="contactMsisdn" placeholder="Phone Number">
						<label for="contactMsisdn">Phone Number</label>
						<div *ngIf="controlInvalid('contact.msisdn')" class="text-danger">{{ getError('contact.msisdn') }}</div>
					</div>
					<div class="form-floating mb-2">
						<input type="text" class="form-control" formControlName="jobRole" id="contactJobRole" placeholder="Job Role">
						<label for="jobRole">Job Role</label>
						<div *ngIf="controlInvalid('contact.jobRole')" class="text-danger">{{ getError('contact.jobRole') }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col" formArrayName="contacts" *ngIf="mode=='Edit'">
			<div class="card">
				<div class="card-header">
					<h3>Contact Form</h3>
				</div>
				<div class="card-body">
					<div *ngFor="let contact of contacts.controls; let i = index" [formGroupName]="i" class="border p-3 mb-2 rounded">
						<div class="form-floating mb-2">
							<input type="text" class="form-control" formControlName="fullName" id="contactFullName_{{i}}" placeholder="Full Name">
							<label for="contactFullName_{{i}}">Full Name</label>
						</div>
						<div class="form-floating mb-2">
							<input type="email" class="form-control" formControlName="emailAddress" id="contactEmailAddress_{{i}}" placeholder="Email Address">
							<label for="contactEmailAddress_{{i}}">Email Address</label>
						</div>
						<div class="form-floating mb-2">
							<input type="text" class="form-control" formControlName="msisdn" id="contactMsisdn_{{i}}" placeholder="Phone Number">
							<label for="contactMsisdn_{{i}}">Phone Number</label>
						</div>
						<div class="form-floating mb-2">
							<input type="text" class="form-control" formControlName="jobRole" id="contactJobRole_{{i}}" placeholder="Job Role">
							<label for="jobRole_{{i}}">Job Role</label>
						</div>
						<button type="button" (click)="removeContact(i)" class="btn btn-danger btn-sm">Remove</button>
					</div>
					<button type="button" (click)="addContact()" class="btn btn-outline-primary mt-2">Add Contact</button>
				</div>
			</div>
		</div>
		<div class="col">
			<div class="card">
				<div class="card-header">
					<h3>Partner Logo</h3>
				</div>
				<div class="card-body">
					<nz-upload
						nzType="drag"
						[nzCustomRequest]="customUpload"
						[nzBeforeUpload]="beforeUpload"
						(nzChange)="handleChange($event)"
						[nzShowUploadList]="false">
						<ng-container *ngIf="imagePreview; else iconTemplate">
						<img [src]="imagePreview" alt="preview" style="max-height: 150px; display: block; margin: auto;" />
						</ng-container>
						<ng-template #iconTemplate>
						<p class="ant-upload-drag-icon">
							<i nz-icon nzType="plus-square"></i>
						</p>
						</ng-template>
					</nz-upload>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<button type="submit" class="float-end btn btn-primary" [disabled]="!partnerForm.valid">Submit</button>
			<!-- [{{getFormValidationErrors(partnerForm)|json}}] -->
		</div>
	</div>
</form>
